export const materialTabConsts = {
  ADD_MATERIAL_TXT: "+ Add Material",
  NO_MATERIALS_AVAILABLE: "No Materials Available",
};

export const materialCategoryColumn = [
  {
    key: "materialCategory",
    dataIndex: "materialCategory",
    width: "100px",
  },
];
